import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "../store";
import * as Web3 from "web3";
import {
  BUSD_ADDRESS,
  STAKING_CONTRACT_ADDRESS,
  PHX_CONTRACT_ADDRESS,
  PHX_ADDRESS,
  USDT_CONTRACT_ADDRESS,
  USDT_ADDRESS,
  BNB_CONTRACT_ADDRESS,
} from "../constant";
import { WalletContext } from "../context/wallet";
import {
  BUSDABI,
  STAKING_POOL,
  PHXABI,
  PHX_STAKING_POOL,
  USDTABI,
  USDT_STAKING_POOL,
  BNB_STAKING_POOL,
} from "../abi";
import BigNumber from "bignumber.js";
import useClipboard from "react-use-clipboard";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Dropdown from "react-bootstrap/Dropdown";
import StakeBox from "./StakeBox";

const Home = () => {
  const global = useContext(StoreContext);
  const [walletAddress] = useContext(WalletContext);
  const [link] = useState(window.location + "/stake/?ref=");

  const info = [
    { apy: 12, days: "Flexible", index: 0, status: true },
    { apy: 20, days: "7 days", index: 1, status: false },
    { apy: 25, days: "14 days", index: 2, status: false },
    { apy: 30, days: "30 days", index: 3, status: false },
    { apy: 75, days: "180 days", index: 4, status: false },
    { apy: 150, days: "365 days", index: 5, status: false },
  ];

  return (
    <div className="mb-5">
      <div className="section section--pb0 section--first">
        <div className="section__article-head"></div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "20px 0px",
          }}
        >
          <button>Claim your Renq rewards before pool time expires</button>
        </div>
      </div>

      <div className="section section--article mt-5">
        <div className="container">
          <div className="row">
            {info.map((item, index) => (
              <StakeBox
                item={item}
                index={item.index}
                key={index}
                walletAddress={walletAddress}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
